/**
 * Sprachwahl an **einer** Stelle.
 *
 * Es gibt zwei Speicher: `localStorage` (dieses Geraet, wirkt sofort und auch
 * ohne Anmeldung) und `users.locale` (das Konto, gilt auf dem naechsten
 * Geraet). Beide auseinanderlaufen zu lassen waere ein Fehler, deshalb
 * schreiben Kopfzeilen-Umschalter und Konto-Seite ueber denselben Hook.
 *
 * Reihenfolge beim Start: gespeicherte Wahl → Kontosprache → Browsersprache →
 * Deutsch (i18n.md); das Zusammenspiel steht in `i18n/index.ts`
 * (`applyAccountLocale`).
 */
import type { Locale } from '@tickethub/shared';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { isLocale, setLocale } from '@/i18n';
import { toastError } from './errors';
import { meApi } from './me';
import { useSession } from './session';

export function useLocalePreference(): { locale: Locale; setLocale: (next: Locale) => void } {
  const { t, i18n: instance } = useTranslation();
  const { user, applyUser } = useSession();

  const current = isLocale(instance.language) ? instance.language : 'de';

  const change = useCallback(
    (next: Locale) => {
      // Zuerst umschalten: die Oberflaeche soll nicht auf das Netz warten.
      setLocale(next);
      if (!user) return;
      void (async () => {
        try {
          applyUser(await meApi.updateProfile({ locale: next }));
        } catch (error) {
          toastError(error, t);
        }
      })();
    },
    [user, applyUser, t],
  );

  return { locale: current, setLocale: change };
}
